import { Type, Static } from '@sinclair/typebox';

// 🔔 Notification Message Schema - Real-time communication contract
// Simple notification fields for WebSocket messaging between server and frontend
export const NotificationMessageSchema = Type.Object(
  {
    id: Type.Number(),
    title: Type.String(),
    message: Type.String(),
    type: Type.Union([
      Type.Literal('info'),
      Type.Literal('success'),
      Type.Literal('warning'),
      Type.Literal('error'),
    ]),
    user_id: Type.Number(),
    is_read: Type.Boolean(),
    created_at: Type.String({ format: 'date-time' }),
    entity_url: Type.Optional(Type.Union([Type.String(), Type.Null()])),
    entity_type: Type.Optional(Type.Union([Type.String(), Type.Null()])),
    payload: Type.Optional(Type.Union([Type.Any(), Type.Null()])),
    // Дедупликация: сколько событий схлопнуто в это уведомление (1 — повторов не было)
    group_count: Type.Optional(Type.Number()),
    // Время последнего события группы — по нему клиент сортирует ленту
    last_event_at: Type.Optional(Type.Union([Type.String({ format: 'date-time' }), Type.Null()])),
    // Ключ группы — по нему область уведомлений узнаёт свои (см. NotificationScopeRegistry)
    dedup_key: Type.Optional(Type.Union([Type.String(), Type.Null()])),
  },
  { $id: 'NotificationMessage' }
);

// 🔔 TypeScript type automatically inferred from schema
export type NotificationMessage = Static<typeof NotificationMessageSchema>;

/**
 * 🔖 Маркер непрочитанного уведомления — сводка без текстов.
 *
 * По нему считаются бейджи разделов: областям нужен только признак «чьё это
 * уведомление» и идентификатор объекта, а не заголовок с сообщением. Записей
 * мало именно благодаря дедупликации — по одному объекту она одна.
 */
export const NotificationMarkerSchema = Type.Object(
  {
    id: Type.Number(),
    dedup_key: Type.Union([Type.String(), Type.Null()]),
    entity_type: Type.Union([Type.String(), Type.Null()]),
    entity_url: Type.Union([Type.String(), Type.Null()]),
    group_count: Type.Number(),
  },
  { $id: 'NotificationMarker' }
);

export type NotificationMarker = Static<typeof NotificationMarkerSchema>;
